export default {
	name: 'Artikelgrupper',
	singular: 'Artikelgrupp',
	icon: 'wrench',
    ownView: 'ArticleGroups',
	slug: 'article-groups',
	isCustom: true,
	access: ['superadmin', 'admin', 'reseller']
}